import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 0;
  padding: 1.5rem;
`;

export const HeaderSection = styled.div`
  margin-bottom: 1rem;
`;

export const Title = styled.h2`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
`;

export const SubTitle = styled.h4`
  font-size: 0.875rem;
  color: #6b7280;
`;

export const FilterGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 1rem;
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const FilterColumn = styled.div`
  grid-column: span 1;
`;

export const Label = styled.label`
  display: block;
  font-size: 0.875rem;
  font-weight: 500;
  color: #374151;
  margin-bottom: 0.25rem;
`;

export const ButtonGroup = styled.div`
  display: flex;
  gap: 0.5rem;
  align-items: flex-end;
  margin-left: auto;
`;

export const PrimaryButton = styled.button`
  background-color: #59249b;
  color: white;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  border: none;
  cursor: pointer;
  &:hover {
    background-color: #59249b;
  }
`;

export const SecondaryButton = styled.button`
  background-color: white;
  color: #59249b;
  padding: 0.5rem 1rem;
  border-radius: 0.25rem;
  border: 1px solid #59249b;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

export const ChartGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 0.75rem;
  margin-bottom: 1rem;

  @media (min-width: 768px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

export const ChartCard = styled.div`
  background-color: white;
  padding: 0.75rem;
  border-radius: 0.5rem;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
  canvas {
    max-width: 25vw;
    max-height: 200px;
  }
`;

export const ChartTitle = styled.h3`
  font-weight: 600;
  font-size: 0.9rem;
  margin-bottom: 0.75rem;
`;
